import { render } from "./menuLink.vue?vue&type=template&id=7f323c0d&ts=true"
import script from "./menuLink.vue?vue&type=script&lang=ts"
export * from "./menuLink.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__